module.exports = "/images/alert.svg?c1256185aa8a3d15d2e65c29b6fd1ae6";